import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import FrontPageContainer from "../components/FrontPage/FrontPageContainer";
import LoginPage from "./LoginPage";
import CallbackPage from "./Callback";

import { setUser } from "../actions/actionsBase";
import { actionTypes } from "../types/enums";
import { getValidUser } from "./AuthService";

export default function App() {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.oidc);
  const [authChecked, setAuthChecked] = React.useState(false);
  const isCallback = window.location.pathname.startsWith("/callback");

  useEffect(() => {
    getValidUser().then((user) => {
      if (user) {
        dispatch(setUser(actionTypes.SET_USER, user));
      } else {
        dispatch(setUser(actionTypes.SET_USER, null));
      }
      setAuthChecked(true);
    });
  }, [dispatch]);

  // ✅ WAIT before doing anything
  if (!authChecked) {
    return <div>Loading authentication...</div>;
  }

  // ✅ NOW safe
  if ((!user || user.expired) && !isCallback) {
    return <LoginPage />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/callback" element={<CallbackPage />} />
        <Route path="/" element={<FrontPageContainer />} />
        <Route path="/annorail" element={<FrontPageContainer />} />
      </Routes>
    </BrowserRouter>
  );
}

